<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item v-if="isJourneyUser == 0" label="选择基地：" prop="journeyBaseId">
            <el-select style="width: 420px;" v-model="ruleForm.journeyBaseId" @change="selectHandleChange" placeholder="请选择基地">
              <el-option v-for="(item,index) in baseList" :key="index" :label="item.baseName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属分类：" prop="categoryId">
            <el-select style="width: 420px;" v-model="ruleForm.categoryId" placeholder="请选择所属分类">
              <el-option v-for="(item,index) in cateList" :key="index" :label="item.categoryName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="视频名称：" prop="name">
            <el-input style="width: 400px;" v-model="ruleForm.name" placeholder="请输入视频名称"></el-input>
          </el-form-item>
          <el-form-item label="视频封面：" prop="imgUrl">
            <el-upload
              :action="baseUrl+'/system/common/upload/uploadFile'"
              list-type="picture-card"
              :headers="{'Authorization': token}"
              :multiple="false"
              :limit="1"
              :file-list="fileList"
              :on-remove="delImgBtn"
              :on-success="bannerImgBtn">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">若需要更换图片，请先删除原图片</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="视频简介：" prop="videoDesc">
            <el-input style="width: 400px;" :rows="4" type="textarea" v-model="ruleForm.videoDesc" placeholder="请输入视频简介"></el-input>
          </el-form-item><el-form-item label="视频：" prop="url">
            <el-input style="width: 400px;" v-model="ruleForm.url" placeholder="请输入视频"></el-input>
          </el-form-item>
          <el-form-item label="视频详情：" prop="detail">
            <editor :value="ruleForm.detail" :height="350" v-model="ruleForm.detail"></editor>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input style="width: 220px;" v-model="ruleForm.sort" placeholder="请输入排序（默认 1 ）"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { querySeleniumJourneyVideoCategoryList, saveSeleniumJourneyVideo, updateSeleniumJourneyVideo, fetchSeleniumJourneyVideoDetailById, queryAllSeleniumJourneyBaseList } from '@/api/xyj'
import Editor from '@/components/Editor.vue'
export default {
  name: 'XyjVideoAdd',
  components: {
    Editor
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      dataId: this.$route.query.dataId,
      fullscreenLoading: false,
      // isJourneyUser 是否属于基地账户 0-否 1-是
      isJourneyUser:1,
      baseList:[],
      fileList: [],
      cateList:[],
      ruleForm: {
        journeyBaseId:'',
        categoryId:'',
        name: '',
        url: '',
        videoDesc: '',
        imgUrl: '',
        detail: '',
        status: false,
        sort: ''
      },
      rules: {
        journeyBaseId: [
          { required: true, message: '请选择基地', trigger: 'blur' }
        ],
        categoryId: [
          { required: true, message: '请选择所属分类', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入视频名称', trigger: 'blur' }
        ],
        imgUrl: [
          { required: true, message: '请上传视频封面图', trigger: 'blur' }
        ],
        videoDesc: [
          { required: true, message: '请输入视频简介', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入视频链接', trigger: 'blur' }
        ],
        detail: [
          { required: true, message: '请输入视频详情', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    var isJourneyUser = sessionStorage.getItem('isJourneyUser');
    this.isJourneyUser = isJourneyUser;
    if(isJourneyUser == 0){
      this.baseListInfoFun();
    }else{
      this.cateFun();
    }
    if (this.$route.query.dataId !== '') {
      let that = this
      fetchSeleniumJourneyVideoDetailById({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.journeyBaseId = data.journeyBaseId
          that.ruleForm.categoryId = data.categoryId
          that.ruleForm.name = data.videoName
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.ruleForm.status = status
          that.ruleForm.sort = data.sort
          that.ruleForm.url = data.videoUrl
          that.ruleForm.imgUrl = data.videoCoverUrl
          that.fileList.push({url: data.videoCoverUrl})
          that.ruleForm.videoDesc = data.videoDesc
          that.ruleForm.detail = data.videoDetail
        }
      });
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 获取基地列表
    baseListInfoFun(){
      var that = this;
      queryAllSeleniumJourneyBaseList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.baseList = data
        }
      })
    },
    // 基地选中的值操作
    selectHandleChange(e){
      this.cateFun();
    },
    // 获取分类列表
    cateFun(){
      let that = this
      querySeleniumJourneyVideoCategoryList({journeyBaseId:that.ruleForm.journeyBaseId}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.cateList = data;
        }
      })
    },
    bannerImgBtn (file) {
      this.ruleForm.imgUrl = file.data.fileUrl
    },
    /* 删除上传的图片 */
    delImgBtn(file,fileList){
      var imgUrl = '';
      fileList.forEach(function(item){
        imgUrl = item.url;
      });
      this.ruleForm.imgUrl = imgUrl;
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let journeyBaseId = that.ruleForm.journeyBaseId
      let categoryId = that.ruleForm.categoryId
      let name = that.ruleForm.name
      let url = that.ruleForm.url
      let imgUrl = that.ruleForm.imgUrl
      let videoDesc = that.ruleForm.videoDesc
      let videoDetail = that.ruleForm.detail
      let status = that.ruleForm.status ? 1 : 0
      let sort = that.ruleForm.sort === '' ? 1 : that.ruleForm.sort
      if (journeyBaseId === '' && that.isJourneyUser === 0) {
        this.$message.error('请选择基地')
        return false
      }
      if (categoryId === '') {
        this.$message.error('请选择所属分类')
        return false
      }
      if (name === '') {
        this.$message.error('请输入视频名称')
        return false
      }
      if (imgUrl === '') {
        this.$message.error('请上传视频封面')
        return false
      }
      if (videoDesc === '') {
        this.$message.error('请输入视频简介')
        return false
      }
      if (url === '') {
        this.$message.error('请输入视频')
        return false
      }
      if (videoDetail === '') {
        this.$message.error('请输入视频详情')
        return false
      }
      let passData = {
        journeyBaseId: journeyBaseId, categoryId: categoryId, videoName: name, videoUrl: url, videoCoverUrl: imgUrl, videoDesc: videoDesc, videoDetail: videoDetail, status: status, sort: sort
      }
      that.fullscreenLoading = true
      if (dataId !== '') {
        passData.id = dataId;
        updateSeleniumJourneyVideo(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        saveSeleniumJourneyVideo(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xyj/VideoAdd.vue